import type { Component, ComponentProps } from 'solid-js';

import { Toaster as Sonner, toast } from 'solid-sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster: Component<ToasterProps> = (props) => {
  return (
    <Sonner
      class="group toaster"
      offset={90}
      position="bottom-right"
      toastOptions={{
        duration: 3000,
        unstyled: true,
        classes: {
          toast:
            'group toast bg-background text-foreground border border-border rounded-lg shadow-xl pl-5 pr-6 py-4 flex gap-3 items-center text-sm',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
          closeButton: 'bg-background text-muted',
          success: 'bg-success text-success-foreground',
          error: 'bg-red-600 text-white border-red-600',
          warning: 'bg-yellow-500 text-black border-yellow-500',
          info: 'bg-blue-600 text-white border-blue-600',
        },
      }}
      {...props}
    />
  );
};

export { toast, Toaster };
